import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Teleport as _Teleport, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tpd-content-layout" }
const _hoisted_2 = { class: "tp-dashboard-tab mb-30" }
const _hoisted_3 = { class: "tp-dashboard-tab-title" }
const _hoisted_4 = { class: "tp-dashboard-tab-list" }
const _hoisted_5 = {
  key: 0,
  class: "tpd-course-area"
}
const _hoisted_6 = { class: "tpd-table mb-25" }
const _hoisted_7 = { class: "tpd-table-head" }
const _hoisted_8 = { class: "tpd-table-row" }
const _hoisted_9 = { class: "tpd-quiz-info-sub" }
const _hoisted_10 = { class: "tpd-table-title" }
const _hoisted_11 = {
  class: "tpd-quiz-tm",
  style: {"width":"150px"}
}
const _hoisted_12 = { class: "tpd-table-title" }
const _hoisted_13 = {
  class: "tpd-quiz-tm",
  style: {"width":"150px"}
}
const _hoisted_14 = { class: "tpd-table-title" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "tpd-quiz-details" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "tpd-table-title" })
], -1 /* HOISTED */)
const _hoisted_16 = {
  key: 0,
  class: "placeholder-glow"
}
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"tpd-table-row gap-2 mr-4\"><div class=\"placeholder rounded w-100\" style=\"height:30px;\"></div><div class=\"placeholder rounded w-50\" style=\"height:30px;\"></div><div class=\"placeholder rounded w-50\" style=\"height:30px;\"></div><div class=\"placeholder rounded w-25\" style=\"height:30px;\"></div></div>", 1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "tpd-table-row" }
const _hoisted_20 = {
  class: "tpd-quiz-info-sub",
  style: {"width":"360px"}
}
const _hoisted_21 = { class: "tpd-common-date" }
const _hoisted_22 = { class: "tpd-quiz-title" }
const _hoisted_23 = { class: "tpd-student-info" }
const _hoisted_24 = {
  class: "tpd-quiz-tm",
  style: {"width":"150px"}
}
const _hoisted_25 = { class: "tpd-common-text" }
const _hoisted_26 = {
  class: "tpd-quiz-tm",
  style: {"width":"150px"}
}
const _hoisted_27 = {
  class: "tpd-quiz-details",
  style: {"min-width":"75px"}
}
const _hoisted_28 = { class: "tpd-quiz-details-btn" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-arrow-right ml-1" }, null, -1 /* HOISTED */)
const _hoisted_31 = {
  key: 1,
  class: "text-orange text-right"
}
const _hoisted_32 = {
  key: 1,
  class: "text-danger text-right"
}
const _hoisted_33 = {
  key: 1,
  class: "text-danger d-flex align-items-center gap-2"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-info-circle",
  style: {"font-size":"34px"}
}, null, -1 /* HOISTED */)
const _hoisted_35 = { class: "d-flex flex-column gap-0" }
const _hoisted_36 = { style: {"font-size":"14px","font-weight":"600","line-height":"20px"} }
const _hoisted_37 = { class: "text-secondary" }
const _hoisted_38 = {
  key: 1,
  class: "profile-card-body"
}
const _hoisted_39 = {
  key: 1,
  class: "tpd-course-area"
}
const _hoisted_40 = { class: "tpd-table mb-25" }
const _hoisted_41 = { class: "tpd-table-head" }
const _hoisted_42 = { class: "tpd-table-row" }
const _hoisted_43 = { class: "tpd-quiz-info-sub" }
const _hoisted_44 = { class: "tpd-table-title" }
const _hoisted_45 = { class: "tpd-quiz-ques" }
const _hoisted_46 = { class: "tpd-table-title" }
const _hoisted_47 = { class: "tpd-quiz-tm" }
const _hoisted_48 = { class: "tpd-table-title" }
const _hoisted_49 = { class: "tpd-quiz-result-sub" }
const _hoisted_50 = { class: "tpd-table-title" }
const _hoisted_51 = { class: "tpd-quiz-details" }
const _hoisted_52 = { class: "tpd-table-title" }
const _hoisted_53 = {
  key: 0,
  class: "placeholder-glow"
}
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<div class=\"tpd-table-row gap-2 mr-4\"><div class=\"placeholder rounded w-100\" style=\"height:30px;\"></div><div class=\"placeholder rounded w-50\" style=\"height:30px;\"></div><div class=\"placeholder rounded w-50\" style=\"height:30px;\"></div><div class=\"placeholder rounded w-25\" style=\"height:30px;\"></div></div>", 1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = { class: "tpd-table-row" }
const _hoisted_57 = { class: "tpd-quiz-info-sub" }
const _hoisted_58 = { class: "tpd-common-date" }
const _hoisted_59 = { class: "tpd-quiz-title" }
const _hoisted_60 = { class: "tpd-student-info" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", null, "Course: ", -1 /* HOISTED */)
const _hoisted_62 = { class: "tpd-quiz-ques" }
const _hoisted_63 = { class: "tpd-common-text" }
const _hoisted_64 = { class: "tpd-quiz-tm" }
const _hoisted_65 = { class: "tpd-table-title" }
const _hoisted_66 = { class: "tpd-quiz-result-sub" }
const _hoisted_67 = { class: "tpd-badge-item" }
const _hoisted_68 = {
  key: 0,
  class: "tpd-badge sucess"
}
const _hoisted_69 = {
  key: 1,
  class: "tpd-badge danger"
}
const _hoisted_70 = { class: "tpd-quiz-details" }
const _hoisted_71 = { class: "tpd-quiz-details-btn" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  class: "modal fade",
  id: "quizAnswersModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_74 = { class: "modal-dialog modal-lg" }
const _hoisted_75 = { class: "modal-content" }
const _hoisted_76 = { class: "modal-header" }
const _hoisted_77 = { class: "modal-title fs-5" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */)
const _hoisted_79 = { class: "text-center mt-3" }
const _hoisted_80 = { class: "mt-3" }
const _hoisted_81 = { class: "text-secondary" }
const _hoisted_82 = {
  key: 0,
  class: "text-success"
}
const _hoisted_83 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_84 = { class: "text-dark" }
const _hoisted_85 = {
  class: "alert alert-secondary mt-3",
  style: {"padding":"5px 10px"}
}
const _hoisted_86 = { class: "mb-0 font-s-13 text-dark" }
const _hoisted_87 = { class: "list-group list-group-numbered" }
const _hoisted_88 = { class: "ms-2 me-auto" }
const _hoisted_89 = ["innerHTML"]
const _hoisted_90 = { class: "d-flex gap-2" }
const _hoisted_91 = { class: "font-s-13 text-secondary" }
const _hoisted_92 = { class: "fw-bold" }
const _hoisted_93 = { class: "font-s-13 text-secondary" }
const _hoisted_94 = { class: "fw-bold" }
const _hoisted_95 = {
  key: 0,
  class: "badge text-bg-success rounded-pill text-center font-s-14",
  style: {"min-width":"30px"}
}
const _hoisted_96 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-check" }, null, -1 /* HOISTED */)
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = {
  key: 1,
  class: "badge text-bg-danger rounded-pill text-center font-s-14",
  style: {"min-width":"30px"}
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-times" }, null, -1 /* HOISTED */)
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = { class: "modal-footer" }
const _hoisted_102 = {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Pagination = _resolveComponent("Pagination")
  const _component_QuizDetails = _resolveComponent("QuizDetails")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" dashboard-content-area-start "),
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" dashboard-tab-area "),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString($setup.lms_website.__('My Quiz')), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["pointer-event", ($data.quiz.active_tab==='completed')?'active':'']),
                onClick: _cache[0] || (_cache[0] = $event => ($data.quiz.active_tab='completed'))
              }, [
                _createTextVNode(_toDisplayString($setup.lms_website.__('Completed Quiz')) + " ", 1 /* TEXT */),
                _createElementVNode("span", null, "(" + _toDisplayString($data.quiz.completed.length) + ")", 1 /* TEXT */)
              ], 2 /* CLASS */)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["pointer-event", ($data.quiz.active_tab==='upcoming_quiz')?'active':'']),
                onClick: _cache[1] || (_cache[1] = $event => ($data.quiz.active_tab='upcoming_quiz'))
              }, [
                _createTextVNode(_toDisplayString($setup.lms_website.__('Upcoming Quiz')) + " ", 1 /* TEXT */),
                _createElementVNode("span", null, "(" + _toDisplayString($data.quiz.upcoming_quiz.length) + ")", 1 /* TEXT */)
              ], 2 /* CLASS */)
            ])
          ])
        ])
      ]),
      ($data.quiz.active_tab==='upcoming_quiz')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!$data.quiz.active_quiz)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("h4", _hoisted_10, _toDisplayString($setup.lms_website.__('Quiz Info')), 1 /* TEXT */)
                          ]),
                          ($data.timeZoneValid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("h4", _hoisted_12, _toDisplayString($setup.lms_website.__('Start At')), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("h4", _hoisted_14, _toDisplayString($setup.lms_website.__('End At')), 1 /* TEXT */)
                                ])
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                          _hoisted_15
                        ])
                      ]),
                      ($data.quiz.loading)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_16, _hoisted_18))
                        : _createCommentVNode("v-if", true),
                      (!$data.quiz.loading || !$data.quiz.active_quiz?.name)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($options.paginatedUpcoming, (row) => {
                            return (_openBlock(), _createElementBlock("li", null, [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("span", _hoisted_21, _toDisplayString($setup.moment(row.creation).format('MMMM DD, YYYY')), 1 /* TEXT */),
                                  _createElementVNode("h4", _hoisted_22, _toDisplayString(row.quiz.title), 1 /* TEXT */),
                                  _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("p", null, [
                                      _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Course')) + ": ", 1 /* TEXT */),
                                      _createTextVNode(" " + _toDisplayString(row.course.title), 1 /* TEXT */)
                                    ])
                                  ])
                                ]),
                                ($data.timeZoneValid)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("span", _hoisted_25, _toDisplayString($setup.moment(`${row.from_date} ${row.start_time}`).format('DD, MMM - hh:mm A')), 1 /* TEXT */)
                                      ]),
                                      _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["tpd-common-text", ($options.checkQuizDateEnd(`${row.to_date} ${row.end_time}`))?'text-danger text-decoration-line-through':'text-success'])
                                        }, _toDisplayString($setup.moment(`${row.to_date} ${row.end_time}`).format('DD, MMM - hh:mm A')), 3 /* TEXT, CLASS */)
                                      ])
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("div", _hoisted_28, [
                                    ($data.timeZoneValid)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (!$options.checkQuizDateEnd(`${row.to_date} ${row.end_time}`))
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                ($options.checkQuizStartTime(row.start_time))
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      ($options.checkQuizDateStart(`${row.from_date} ${row.start_time}`))
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            type: "button",
                                                            onClick: $event => ($options.openQuiz(row)),
                                                            style: {"width":"80px"},
                                                            class: "btn btn-sm btn-primary rounded pointer-event"
                                                          }, [
                                                            _createTextVNode(_toDisplayString($setup.lms_website.__('Start')) + " ", 1 /* TEXT */),
                                                            _hoisted_30
                                                          ], 8 /* PROPS */, _hoisted_29))
                                                        : _createCommentVNode("v-if", true)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                                  : _createCommentVNode("v-if", true),
                                                (!$options.checkQuizDateStart(`${row.from_date} ${row.start_time}`) || !$options.checkQuizStartTime(row.start_time))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString($setup.lms_website.__('Not Started')), 1 /* TEXT */))
                                                  : _createCommentVNode("v-if", true)
                                              ], 64 /* STABLE_FRAGMENT */))
                                            : _createCommentVNode("v-if", true),
                                          ($options.checkQuizDateEnd(`${row.to_date} ${row.end_time}`))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString($setup.lms_website.__('Ended')), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : _createCommentVNode("v-if", true),
                                    (!$data.timeZoneValid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                          _hoisted_34,
                                          _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("span", _hoisted_36, _toDisplayString($setup.lms_website.__('Your Device Time is Invalid')), 1 /* TEXT */),
                                            _createElementVNode("small", _hoisted_37, _toDisplayString($setup.lms_website.__('Set your device time to your local time in Egypt')), 1 /* TEXT */)
                                          ])
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ])
                              ])
                            ]))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  (!$data.quiz.loading)
                    ? (_openBlock(), _createBlock(_component_Pagination, {
                        key: 0,
                        "current-page": $data.quiz.pagination.upcoming_quiz.currentPage,
                        "total-items": $data.quiz.upcoming_quiz.length,
                        "items-per-page": $data.quiz.pagination.upcoming_quiz.itemsPerPage,
                        onPageChanged: $options.handleUpcomingPageChange
                      }, null, 8 /* PROPS */, ["current-page", "total-items", "items-per-page", "onPageChanged"]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            ($data.quiz.active_quiz && $data.quiz.active_quiz?.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createVNode(_component_QuizDetails, {
                    "quiz-data": $data.quiz.active_quiz
                  }, null, 8 /* PROPS */, ["quiz-data"])
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      ($data.quiz.active_tab==='completed')
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("h4", _hoisted_44, _toDisplayString($setup.lms_website.__('Quiz Info')), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("h4", _hoisted_46, _toDisplayString($setup.lms_website.__('Percentage')), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("h4", _hoisted_48, _toDisplayString($setup.lms_website.__('Score')), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("h4", _hoisted_50, _toDisplayString($setup.lms_website.__('Status')), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("h4", _hoisted_52, _toDisplayString($setup.lms_website.__('Details')), 1 /* TEXT */)
                    ])
                  ])
                ]),
                ($data.quiz.loading)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_53, _hoisted_55))
                  : _createCommentVNode("v-if", true),
                (!$data.quiz.loading)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($options.paginatedCompleted, (row) => {
                      return (_openBlock(), _createElementBlock("li", null, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("span", _hoisted_58, _toDisplayString($setup.moment(row.creation).format('MMMM DD, YYYY')), 1 /* TEXT */),
                            _createElementVNode("h4", _hoisted_59, _toDisplayString(row.quiz.title), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("p", null, [
                                _hoisted_61,
                                _createTextVNode(" " + _toDisplayString(row.course.title), 1 /* TEXT */)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("span", _hoisted_63, _toDisplayString(row.percentage) + "%", 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("h4", _hoisted_65, _toDisplayString(row.score) + "/" + _toDisplayString(row.score_out_of), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              (row.custom_status==='Success')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString($setup.lms_website.__('Passed')), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              (row.custom_status==='Failed')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString($setup.lms_website.__('Failed')), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("a", {
                                onClick: $event => ($options.showQuizAnswers(row)),
                                class: "tpd-border-btn pointer-event"
                              }, _toDisplayString($setup.lms_website.__('Details')), 9 /* TEXT, PROPS */, _hoisted_72)
                            ])
                          ])
                        ])
                      ]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            (!$data.quiz.loading)
              ? (_openBlock(), _createBlock(_component_Pagination, {
                  key: 0,
                  "current-page": $data.quiz.pagination.completed.currentPage,
                  "total-items": $data.quiz.completed.length,
                  "items-per-page": $data.quiz.pagination.completed.itemsPerPage,
                  onPageChanged: $options.handleCompletedPageChange
                }, null, 8 /* PROPS */, ["current-page", "total-items", "items-per-page", "onPageChanged"]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("h1", _hoisted_77, _toDisplayString($data.modal.data?.quiz?.quiz?.title), 1 /* TEXT */),
              _hoisted_78
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["modal-body min-height-100", {'form-loading':($data.modal.loading)}])
            }, [
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("h3", _hoisted_80, [
                  _createElementVNode("span", _hoisted_81, _toDisplayString($setup.lms_website.__('You got {0}%', [$data.modal.data?.quiz?.percentage])) + " - ", 1 /* TEXT */),
                  ($data.modal.data?.quiz?.custom_status==='Success')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString($setup.lms_website.__('Passed')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  ($data.modal.data?.quiz?.custom_status==='Failed')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString($setup.lms_website.__('Failed')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("p", _hoisted_84, _toDisplayString($setup.lms_website.__('Your score is {0}/{1}.', [$data.modal.data?.quiz?.score, $data.modal.data?.quiz?.score_out_of])), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("p", _hoisted_86, _toDisplayString($setup.lms_website.__('You must get {0}% of correct answers to pass the quiz.', [$data.modal.data?.quiz?.passing_percentage])), 1 /* TEXT */)
              ]),
              _createElementVNode("ol", _hoisted_87, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.showAnswers, (answer) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: answer.name,
                    class: "list-group-item d-flex justify-content-between align-items-start"
                  }, [
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("div", {
                        class: "fw-bold margin-p-0",
                        innerHTML: answer.question
                      }, null, 8 /* PROPS */, _hoisted_89),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("span", _hoisted_92, _toDisplayString($setup.lms_website.__('Answer')) + ": ", 1 /* TEXT */),
                          _createTextVNode(" " + _toDisplayString(answer.answer), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("span", _hoisted_94, _toDisplayString($setup.lms_website.__('Mark')) + ": ", 1 /* TEXT */),
                          _createTextVNode(" (" + _toDisplayString(answer.marks) + ")", 1 /* TEXT */)
                        ])
                      ])
                    ]),
                    (answer.is_correct)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_95, _hoisted_97))
                      : _createCommentVNode("v-if", true),
                    (!answer.is_correct)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_98, _hoisted_100))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ], 2 /* CLASS */),
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("button", _hoisted_102, _toDisplayString($setup.lms_website.__('Close')), 1 /* TEXT */)
            ])
          ])
        ])
      ])
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}